import { Button } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { hasPermissionForAccount } from '../../Utility/PermissionsUtil';

const MeterReadingAppBar = () => {
    const chosenAccount = useSelector(state => state.chosenAccount.account);
    const roles = useSelector(state => state.auth.roles);
    const history = useHistory();

    const buildUploadMeterReadingMenu = () => {
        if (hasPermissionForAccount(roles, chosenAccount.id, "ROLE_save_meter_value")) {
            return (<Button onClick={() => history.push("/meter-reading/account/" + chosenAccount.id + "/upload")}>Upload Meter Data</Button>);
        }
    }

    const buildMeterAccountsMenu = () => {
        if (hasPermissionForAccount(roles, chosenAccount.id, "ROLE_retrieve_meter_account")) {
            return (<Button onClick={() => history.push("/meter-reading/account/" + chosenAccount.id + "/meter-account")}>Meter Accounts</Button>);
        }
    }

    const buildGenerationMeterValuesMenu = () => {
        if (hasPermissionForAccount(roles, chosenAccount.id, "ROLE_retrieve_meter_values")) {
            return (<Button onClick={() => history.push("/meter-reading/account/" + chosenAccount.id + "/meter")}>Generation Meters</Button>);
        }
    }

    const buildMonthlyCorrectionMenu = () => {
        if (hasPermissionForAccount(roles, chosenAccount.id, "ROLE_retrieve_monthly_correction") || hasPermissionForAccount(roles, chosenAccount.id, "ROLE_submit_monthly_correction")) {
            return <Button onClick={() => history.push("/meter-reading/account/" + chosenAccount.id + "/meter/correction")}>Monthly Correction</Button>
        }
    }

    const buildNotificationListMenu = () => {
        if (hasPermissionForAccount(roles, chosenAccount.id, "ROLE_create_power_meter_notification_list") || hasPermissionForAccount(roles, chosenAccount.id, "ROLE_retrieve_power_meter_notification_list")) {
            return <Button onClick={() => history.push("/meter-reading/account/" + chosenAccount.id + "/notifications")}>Notifications</Button>
        }
    }

    return (
        <React.Fragment>
            {buildGenerationMeterValuesMenu()}
            {buildMonthlyCorrectionMenu()}
            {buildMeterAccountsMenu()}
            {buildUploadMeterReadingMenu()}
            {buildNotificationListMenu()}
        </React.Fragment>
    )
}

export default MeterReadingAppBar;